"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importDefault(require("react"));
const Selector = () => {
    const theme = (0, theme_1.useTheme)();
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: theme.colors.surface.brand, xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("rect", { width: "24", height: "24", rx: "10", fill: theme.colors.surface.brand }),
        react_1.default.createElement("path", { d: "M6 12.95L11 17L18 7", stroke: theme.colors['on-accent'].primary, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
exports.Selector = Selector;
